import { useEffect, useState } from "react";
import { getDropdownData } from "../../api/designerPage";
import { DropdownData } from "../../../interface/DesignerInterface";

export function useDropdownData() {
  const [genres, setGenres] = useState<string[]>([]);
  const [regions, setRegions] = useState<string[]>([]);
  const [sources, setSources] = useState<string[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    getDropdownData().then(res => {
      setGenres(res.genres.map((i: DropdownData) => i.name));
      setRegions(res.regions.map((i: DropdownData) => i.name));
      setSources(res.sources.map((i: DropdownData) => i.name));
      setCategories(res.categories.map((i: DropdownData) => i.name));
    });
  }, []);

  return {
    genres,
    regions,
    sources,
    categories,
    setGenres,
    setRegions,
    setSources,
    setCategories,
  };
}
